<template>
  <generic-modal :title="$t('expedient type')" ref="generic_modal">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("expedient type name") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.name"
              :placeholder="$t('expedient type name')"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half">
        <div class="field">
          <label class="label">{{ $t("color") }}</label>
          <div class="control">
            <input class="input" type="color" v-model="meta.color" />
          </div>
        </div>
      </div>
      <div class="column is-half">
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_is_active"
            v-model="meta.is_active"
          />
          <label for="chk_is_active">{{ $t("active") }}</label>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("description") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              v-model="meta.description"
              :placeholder="$t('description')"
              rows="3"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon"><i class="fa fa-save"></i></span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon"><i class="fa fa-trash"></i></span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  post,
  del,
  get,
  generate_error_message_text,
  confirm_deletion_dialog,
  success_message,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ExpedientTypeModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.name;
    },
  },
  methods: {
    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },
    show_modal(uuid = null) {
      this.set_initial_state();
      if (uuid) {
        get("/archive/expedient-type", { uuid })
          .then((expedient_type) => {
            this.meta = expedient_type;
            this.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      } else {
        this.$refs.generic_modal.show_modal();
      }
    },
    save() {
      const method = this.meta.uuid ? post : put;
      method("/archive/expedient-type", this.meta)
        .then(() => {
          this.$emit("success");
          success_message(this.$t("record saved"));
          this.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        });
    },
    remove() {
      confirm_deletion_dialog(
        this.$t("are you sure delete expedient type"),
        this,
        () => {
          del("/archive/expedient-type", { uuid: this.meta.uuid })
            .then(() => {
              this.$emit("success");
              success_message(this.$t("record deleted"));
              this.$refs.generic_modal.close_modal();
            })
            .catch((error) => {
              this.error = generate_error_message_text(error);
            });
        }
      );
    },
    set_initial_state() {
      this.meta = {
        name: "",
        color: "#e74c3c",
        description: "",
        is_active: true,
      };
      this.error = "";
    },
  },
};
</script>
